import { render, staticRenderFns } from "./IconLockClosedSolid.vue?vue&type=template&id=14cfb48d"
import script from "./IconLockClosedSolid.vue?vue&type=script&lang=js"
export * from "./IconLockClosedSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports